import { Button, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import {
  getAllDocument,
  uploadDocument,
} from '../../pages/Document/DocumentSlice';

import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

function ModalUploadFile({ setShow, show }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');

  const [file, setFile] = useState();
  const [fileName, setFileName] = useState('Chọn file...');

  const handleClose = () => setShow(false);

  const handleUploadDocument = async () => {
    await dispatch(uploadDocument({ token, file, title: fileName }));
    await dispatch(getAllDocument({ token }));
    setShow(false);
    setFileName('Chọn file...');
  };

  const handleChooseFile = (e) => {
    setFile(e.target.files[0]);
    setFileName(e.target.files[0].name);
  };

  return (
    <Modal onHide={handleClose} show={show} scrollable>
      <Modal.Header closeButton>
        <Modal.Title>{t('add-document')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-body">
          <div className="custom-file">
            <input
              type="file"
              name="file"
              onChange={handleChooseFile}
              className="custom-file-input"
              id="file"
              required
            />
            <label
              className="custom-file-label"
              id="document"
              for="validatedCustomFile"
            >
              {fileName}
            </label>
            <div className="invalid-feedback">
              Example invalid custom file feedback
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleUploadDocument}>
          {t('add-new')}
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          {t('close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalUploadFile;
